import { Component, forwardRef } from "react";
import Header from "../../../common_components/Header";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  downloadReport,
  exhibitorTypeActionId,
  toastError,
  toastSuccess,
  reminderEventActionId,
} from "../../../utils/constants";
import AdminHeader from "../../../common_components/admin_module_header";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Workbook from "react-excel-workbook";
import Modal from "react-modal";
import Footerwithdr from "../../../common_components/Footerwithdr";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getHotelEnquiryList_action } from "../../../actions/admin_module_action/hotel_enquiry_action/hotel_enquiry_action";
import moment from "moment";
import {
  exhibitorNameActionId,
  accountTypeActionId,
  currencyActionId,
} from "../../../utils/constants";

class HotelEnquiryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      hotelEnquiryList: [],
      currentPage: 1,
      exhRegistrationNo: "",
      companyName: "",
      loginAccesslist: [],
    };
    this.updateItem = this.updateItem.bind(this);
    this.getDownloadAccess = this.getDownloadAccess.bind(this);
  }

  componentDidMount() {
    this.setState({
      loginAccesslist: JSON.parse(sessionStorage.getItem("loginDataSS"))[
        "loginAccesslist"
      ],
    });
    this.gethotelEnquiryList();
  }

  gethotelEnquiryList() {
    const { hotelEnquiryList, exhRegistrationNo, companyName } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getHotelEnquiryList_action(exhRegistrationNo, companyName)
      .then((data) => {
        if (data.error != 1) {
          // data.data != '' && data.data != null ?

          //     data.data.map((item) => {
          //         item.Is_checked = 0
          //     })

          //     : <></>
          // console.log("data", data)
          this.setState({ isLoading: false, hotelEnquiryList: data.data[0] });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onCreateExcel() {
    const { hotelEnquiryList } = this.state;
    var rowData = [];

    var columnArray = [];
    var list = [];
    hotelEnquiryList.map((item, i) => {
      list[i] = { ...item };
    });
    // debugger
    // if (checkboxDisable) {
    //     list.map((data, index) => {
    //         if (data.Is_checked == 1) {
    //             if (index == 0) {
    //                 delete data.ReceiptID;
    //                 delete data.ExhRegistrationID
    //                 Object.keys(data).map((key, index) => {
    //                     columnArray.push(key)
    //                 })

    //             }
    //         }
    //     })
    // }
    // else {
    // < td className = "text-center" > { data.CheckInDate != '' && data.CheckInDate != null ? moment(data.CheckInDate).format('DD/MM/YYYY') : '' }</td>
    // <td className="text-center">{data. != '' && data.CheckOutDate != null ? moment(data.CheckOutDate).format('DD/MM/YYYY') : ''}</td>
    // <td className="text-center">{data.NoofPax}</td>
    // <td className="text-center">{data.NoofRooms}</td>
    // <td className="text-center">{data.SingleOccupancy}</td>
    // <td className="text-center">{data.DoubleOccupancy}</td>
    // for column data
    list.map((data, index) => {
      if (index == 0) {
        delete data.ExhibitionID;
        delete data.ExhRegistrationID;
        delete data.ExhHotelEnquiryID;
        delete data.ExhRegistrationCompanyName;
        data.CheckInDate =
          data.CheckInDate != "" && data.CheckInDate != null
            ? moment(data.CheckInDate).format("DD/MM/YYYY")
            : "";
        data.CheckOutDate =
          data.CheckOutDate != "" && data.CheckOutDate != null
            ? moment(data.CheckOutDate).format("DD/MM/YYYY")
            : "";
        Object.keys(data).map((key, index) => {
          columnArray.push(key);
        });
      }
    });
    // }

    // if (checkboxDisable) {
    //     // for row data
    //     list.map((data, index) => {
    //         if (data.Is_checked == 1) {
    //             rowData.push(data)
    //         }
    //     })
    // } else {
    // for row data
    list.map((data, index) => {
      rowData.push(data);
    });
    // }
    console.log(columnArray, "columnArray");

    return (
      // <div className="row text-center" style={{ marginLeft: "-1px" }} >
      <>
        <Workbook
          filename="HotelEnquiryList.xlsx"
          element={
            <button
              type="button"
              className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
              disabled={!this.getDownloadAccess()}
            >
              Download EXCEL
            </button>
          }
        >
          <Workbook.Sheet data={rowData} name="Sheet A">
            {columnArray.map((value, index) => (
              <Workbook.Column label={value} value={value} />
            ))}
          </Workbook.Sheet>
        </Workbook>
      </>
      // </div>
    );
  }

  getDownloadAccess() {
    const { loginAccesslist } = this.state;
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == "5");
    if (moduleAccess) {
      return moduleAccess.DownloadAccess;
    } else {
      return false;
    }
    return false;
  }

  updateItem(item) {
    const { hotelEnquiryList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = hotelEnquiryList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(hotelEnquiryList.length / recordsPerPage);
  }

  render() {
    const {
      isLoading,
      hotelEnquiryList,
      currentPage,
      exhRegistrationNo,
      companyName,
    } = this.state;

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = hotelEnquiryList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(hotelEnquiryList.length / recordsPerPage);

    console.log("currentRecords", currentRecords);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <div className="main-content app-content with-dr-container">
          <div class="main-container">
            <AdminDrawer />
            <div class="row m-0">
              <div className="breadcrumb-scroll-fixed">
                <h6 className="mb-0 p-2 text-white">Hotel Enquiry List</h6>
              </div>
            </div>
            <div className="admin-top-space">
              <div class="row m-0 mt-1 pt-3 pb-3">
                <div className="col-md-3">
                  <label>Application No</label>
                  <input
                    type="text"
                    value={exhRegistrationNo}
                    onChange={(e) =>
                      this.setState({ exhRegistrationNo: e.target.value })
                    }
                    class="form-control"
                    name=""
                  />
                </div>
                <div className="col-md-3">
                  <label>Company Name</label>
                  <input
                    type="text"
                    value={companyName}
                    onChange={(e) =>
                      this.setState({ companyName: e.target.value })
                    }
                    class="form-control"
                    name=""
                  />
                </div>
                <div
                  className="col-md-3"
                  style={{ marginTop: "10px", display: "flex" }}
                >
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    onClick={() => this.gethotelEnquiryList()}
                    style={{ height: "34px", marginRight: "20px" }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                    onClick={() =>
                      this.setState(
                        {
                          companyName: "",
                          exhRegistrationNo: "",
                        },
                        () => this.gethotelEnquiryList()
                      )
                    }
                    style={{ height: "34px", marginRight: "20px" }}
                  >
                    Clear
                  </button>
                  {this.onCreateExcel()}
                </div>
              </div>
            </div>
            <div className="row mx-2">
              <div class="table-responsive px-1 sticky-table-wrapper service-list-grid p-0">
                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                  <thead class="table-light">
                    <tr>
                      <th className="text-center">Application No.</th>
                      <th>Applicant Type</th>
                      <th>Company Name</th>
                      <th>Person Name</th>
                      <th>Email</th>
                      <th className="text-center">Mobile No.</th>
                      <th className="text-center">Tentative checkIn Date</th>
                      <th className="text-center">Tentative checkOut Date</th>
                      <th className="text-center">Tentative No. of Pax</th>
                      <th className="text-center">Tentative No. of Rooms</th>
                      <th className="text-center">Single Occupancy</th>
                      <th className="text-center">Double Occupancy</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length > 0 && currentRecords != null ? (
                      currentRecords.map((data, i) => (
                        <tr>
                          <td className="text-center">{data.ApplicationNo}</td>
                          <td className="text-center">{data.ApplicantType}</td>
                          <td style={{ textAlign: "left" }}>
                            {data.CompanyName}
                          </td>
                          <td>{data.PersonName}</td>
                          <td>{data.Email}</td>
                          <td className="text-center">{data.MobileNo}</td>
                          <td className="text-center">
                            {data.CheckInDate != "" && data.CheckInDate != null
                              ? moment(data.CheckInDate).format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td className="text-center">
                            {data.CheckOutDate != "" && data.CheckOutDate != null
                              ? moment(data.CheckOutDate).format("DD/MM/YYYY")
                              : ""}
                          </td>
                          <td className="text-center">{data.NoofPax}</td>
                          <td className="text-center">{data.NoofRooms}</td>
                          <td className="text-center">{data.SingleOccupancy}</td>
                          <td className="text-center">{data.DoubleOccupancy}</td>
                          <td>{data.Remark}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center">
                          Record not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                
              </div>

              <div className="mt-2 float-left">
                  {hotelEnquiryList.length > 0 ? (
                    <Pagination
                      nPages={nPages}
                      currentPage={currentPage}
                      setCurrentPage={this.updateItem}
                    />
                    
                  ) : (
                    <></>
                  )}
                  
                </div>
            </div>
            {/* <div class="footer-sec ">
                            <div class="sdsd">
                                <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
                            </div>
                        </div>

                        <div class="footer-first">
                            <div class="container-fluid">
                                <div class="footer-first">  ITME All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i> 2023  </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, { fill_action, getHotelEnquiryList_action })(HotelEnquiryList)
);
